module.exports = __webpack_public_path__ + "img/pixel.9dc444f0.png";